import {PropsWithChildren, useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import {GrowthBook, GrowthBookProvider as GBP} from '@growthbook/growthbook-react';
import {User} from '../Auth/User';

type GrowthbookProviderProps = PropsWithChildren<unknown>;

export default function GrowthbookProvider({children}: GrowthbookProviderProps): JSX.Element {
    const [gb, setGb] = useState<GrowthBook>();

    const location = useLocation();
    useEffect(() => {
        async function initGb() {
            const gbInstance = new GrowthBook({
                apiHost: 'https://cdn.growthbook.io',
                clientKey: process.env.NEXT_PUBLIC_GROWTHBOOK_CLIENT_KEY || 'sdk-EIX1trTd3UmyMYuO',
                enableDevMode: process.env.NEXT_PUBLIC_SST_STAGE !== 'prod',
                attributes: {
                    email: User.Info.email,
                    browser: navigator.userAgent,
                    url: location?.pathname,
                },
                trackingCallback: (experiment, result) => {
                    // TODO: Use your real analytics tracking system
                    console.log('Viewed Experiment', {
                        experimentId: experiment.key,
                        variationId: result.key,
                    });
                },
            });

            await gbInstance.loadFeatures({autoRefresh: true});
            setGb(gbInstance);
        }

        initGb();
    }, []);

    return <GBP growthbook={gb}>{children}</GBP>;
}
